import { render, staticRenderFns } from "./UserMyProfile.vue?vue&type=template&id=533078d7"
import script from "./UserMyProfile.vue?vue&type=script&lang=js"
export * from "./UserMyProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports